import {
    IDataArray,
    SurveySettings
} from "./../../shared/index"

export enum ConflictResolution {
    MoveExpiresDateToBeforeStartDate,
    MoveStartDateToAfterExpiresDate,
    InactivateSurvey
}

export class SurveyConflictResolution implements IDataArray {
    public Pkid = 0;
    public ExistingSurvey: SurveySettings;
    public CurrentSurvey: SurveySettings;
    public ConflictDescription: string;
    public ConflictResolutionText: string;
    public ConflictResolution: ConflictResolution;

    public GetById(): number {
        return this.Pkid;
    }
}